import { apiClient } from "./apiClient";
import { reverseGeocode } from "./geocodingService";
import { getCurrentPosition } from "./geolocationService";


export const getGarageSlotsData = async (): Promise<any | null> => {

  const getValidIndianPincode = (pincode: any) => {
    if (typeof pincode === "string" && /^[1-9][0-9]{5}$/.test(pincode.trim())) {
      return Number(pincode);
    }
    return null;
  };

  try {
    const { lat, lon } = await getCurrentPosition();
    const geoData = await reverseGeocode(lat, lon);
    const pincode = getValidIndianPincode(geoData?.pincode);

    if (!pincode) {
      console.error("Error While fetching garage service pincode");
      return {
        success: false,
        data: null
      };
    }

    const response = await apiClient.get(
      `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/${process.env.NEXT_PUBLIC_BASE_TERM}api/garage/fetchslots?pincode=${pincode}`,
    );

    return {
      success: true,
      data: response
    };
  } catch (error: any) {
    console.error("Error While fetching garage service Slots data ", error?.message);
    return {
      success: false,
      data: null
    };
  }
}

export const getGarageServiceData = async (userId: string): Promise<any | null> => {
  try {
    const apiUrl = `${process.env.NEXT_PUBLIC_BASE_URL ?? ""}/api/garage?userId=${userId}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (
      !data ||
      (typeof data === "object" && Object.keys(data).length === 0) ||
      data.success === false
    ) {
      return { success: false, data: null };
    }

    const mainKey = Object.keys(data)[0];
    const serviceData = data[mainKey];

    if (
      serviceData?.status_code >= 400 ||
      typeof serviceData?.response?.error === "string"
    ) {
      return { success: false, data: null };
    }

    return {
      success: true,
      data,
    };
  } catch (error: any) {
    console.error("Error while fetching garage service data:", error?.message);
    return {
      success: false,
      data: null,
    };
  }
};
